import { breakpointsVuetify } from '@vueuse/core'
import { VIcon } from 'vuetify/components/VIcon'
import { defineThemeConfig } from '@core'
import { Skins } from '@core/enums'

import { AppContentLayoutNav, ContentWidth, FooterType, NavbarType } from '@layouts/enums'

export const { themeConfig, layoutConfig } = defineThemeConfig({
  app: {
    appName: 'Somos IEF',
    title: 'Institución Educativa la Floresta',
    contentWidth: ContentWidth.Boxed,
    contentLayoutNav: AppContentLayoutNav.Horizontal,
    overlayNavFromBreakpoint: breakpointsVuetify.md + 16,
    i18n: {
      enable: false,
      defaultLocale: 'es',
      langConfig: [
        {
          label: 'Spanish',
          i18nLang: 'es',
          isRTL: false,
        },
        {
          label: 'English',
          i18nLang: 'en',
          isRTL: false,
        },

      ],
    },
    theme: 'light',
    skin: Skins.Default,
    iconRenderer: VIcon,
  },
  navbar: {
    type: NavbarType.Sticky,
    navbarBlur: true,
  },
  footer: { type: FooterType.Static },
  verticalNav: {
    isVerticalNavCollapsed: false,
    defaultNavItemIconProps: { icon: 'tabler-circle', size: 10 },
    isVerticalNavSemiDark: false,
  },
  horizontalNav: {
    type: 'sticky',
    transition: 'slide-y-reverse-transition',
  },

  /*
    // ℹ️  In below Icons section, you can specify icon for each component. Also you can use other props of v-icon component like `color` and `size` for each icon.
    // Such as: chevronDown: { icon: 'tabler-chevron-down', color:'primary', size: '24' },
    */
  icons: {
    chevronDown: { icon: 'tabler-chevron-down' },
    chevronRight: { icon: 'tabler-chevron-right', size: 18 },
    close: { icon: 'tabler-x' },
    verticalNavPinned: { icon: 'tabler-circle-dot' },
    verticalNavUnPinned: { icon: 'tabler-circle' },
    sectionTitlePlaceholder: { icon: 'tabler-separator' },
  },
  socialLinks: [
    { name: 'Facebook', title: 'Facebook', url: 'https://www.facebook.com/IEFlaflorestaMosquera', icon: 'tabler-brand-facebook', subtitle: 'Facebook' },
    { name: 'Instagram', title: 'Instagram', url: 'https://www.instagram.com/ieflafloresta/', icon: 'tabler-brand-instagram', subtitle: 'Instagram' },
    { name: 'YouTube', title: 'YouTube', url: 'https://www.youtube.com/channel/UCwCuXGtf9ztX4qdJV_dIZHQ', icon: 'tabler-brand-youtube', subtitle: 'YouTube' },
    { name: 'WhatsApp', title: 'WhatsApp', url: 'https://api.whatsapp.com/send?phone=573013597368', icon: 'tabler-brand-whatsapp', subtitle: '¡Envianos un mensaje!' },
  ],
})
